import React from 'react';
import styles from './TextSection.module.css';
import {
    OptimizedMotionH2,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const TextSection: React.FC = () => {
    return (
        <div className={styles.container}>
            <OptimizedMotionH2 type="slide-down" delay={0.1} className={styles.title}>
                Faster Iterations,
                <br />
                Fewer Mistakes
            </OptimizedMotionH2>
            <OptimizedMotionP type="slide-down" delay={0.4} className={styles.text}>
                With automatic locking and real‑time conflict detection, two teammates can't
                overwrite each other's work. Combined with AI‑powered content suggestions, teams
                iterate rapidly while reducing human error—launch dates stay firm, and compliance
                teams breathe easier.
            </OptimizedMotionP>
            <div className={styles.blur1}></div>
            <div className={styles.blur2}></div>
        </div>
    );
};

export default TextSection;
